module.exports = __webpack_public_path__ + "img/GMR.14321dcd.svg";